import type { Meetup, NotificationEvent } from '../services/api';

export function reservationStatusKey(status: Meetup['status']) {
  switch (status) {
    case 'pending': return 'calendar.statusPending';
    case 'accepted': return 'calendar.statusAccepted';
    case 'declined': return 'calendar.statusDeclined';
    case 'expired': return 'calendar.statusExpired';
    default: return 'calendar.statusCancelled';
  }
}

export function reservationNotificationStatusKey(
  item: Pick<NotificationEvent, 'type' | 'meetup_status'>,
) {
  // A rejected/withdrawn time proposal leaves its parent reservation accepted.
  // The proposal notification must describe its own result, not the parent.
  if (item.type.includes('_reschedule_') || !item.meetup_status) {
    if (item.type.endsWith('_accepted')) return reservationStatusKey('accepted');
    if (item.type.endsWith('_declined')) return reservationStatusKey('declined');
    if (item.type.endsWith('_cancelled')) return reservationStatusKey('cancelled');
  }
  return reservationStatusKey(item.meetup_status ?? 'cancelled');
}
